export const REGION_IDS = [
  {
    id: 9,
    name: 'Blekinge län',
  },
  {
    id: 25,
    name: 'Dalarnas län',
  },
  {
    id: 8,
    name: 'Gotlands län',
  },
  {
    id: 19,
    name: 'Gävleborgs län',
  },
  {
    id: 11,
    name: 'Hallands län',
  },
  {
    id: 21,
    name: 'Jämtlands län',
  },
  {
    id: 5,
    name: 'Jönköpings län',
  },
  {
    id: 7,
    name: 'Kalmar län',
  },
  {
    id: 6,
    name: 'Kronobergs län',
  },
  {
    id: 23,
    name: 'Norrbottens län',
  },
  {
    id: 10,
    name: 'Skåne län',
  },
  {
    id: 1,
    name: 'Stockholms län',
  },
  {
    id: 3,
    name: 'Södermanlands län',
  },
  {
    id: 2,
    name: 'Uppsala län',
  },
  {
    id: 15,
    name: 'Värmlands län',
  },
  {
    id: 22,
    name: 'Västerbottens län',
  },
  {
    id: 20,
    name: 'Västernorrlands län',
  },
  {
    id: 17,
    name: 'Västmanlands län',
  },
  {
    id: 26,
    name: 'Västra Götalands län',
  },
  {
    id: 16,
    name: 'Örebro län',
  },
  {
    id: 4,
    name: 'Östergötlands län',
  },
];
